export default __webpack_public_path__ + "static/media/b14-med.c4342bdc.jpg";